import LinksField from "./LinksField";
import { MediaManager } from "@/components";

export interface TemplateSetting {
    id: string;
    label: string;
    type: 'image' | 'text' | 'number' | 'link';
    value?: string | File;
    defaultValue: string;
    multiple?: boolean;
    onChange: (field: string, value: any) => void;
}

const TemplateSettingField = ({ id, label, type, value, onChange }: TemplateSetting) => {
    const handleChange = (value: any) => {
        if (type === 'image') {
            onChange(id, value[0]);
        }
        if (type === 'link') {
            onChange(id, value);
        }
    }

    if (type === 'image') {
        return (
            <MediaManager
                label={label}
                value={value}
                onChange={handleChange}
            />
        );
    }
    
    if (type === 'link') {
        return (
            <LinksField
                label={label}
                value={value ?? []}
                onChange={handleChange}
            />
        );
    }

    return null;
}

export default TemplateSettingField;
